import { flow, types } from 'mobx-state-tree';
import { onSnapshot } from 'mobx-state-tree';
import { axiosRequest, CustomErrorModel } from 'shared/api';
import { Clinic, ClinicsApiResponse, ClinicState } from './types';
import { bookingStore } from 'entities/booking';
import { doctorsStore } from 'features/doctors';

const ClinicModel = types.model({
	id: types.number,
	name: types.string,
	info: types.array(types.string),
});

const ClinicItemModel = types.model({
	id: types.number,
	name: types.string,
	address: types.string,
	schedule: types.string,
});

export const ClinicsStore = types
	.model('ClinicsStore', {
		clinics: types.array(ClinicModel),
		clinicsMap: types.optional(types.map(ClinicItemModel), {}),
		error: types.maybeNull(CustomErrorModel),
		loading: types.boolean,
	})
  .views(self => ({
    getClinics: () => {
      return self.clinics;
    }
  }))
	.actions(self => ({
		fetchClinics: flow(function* (specId?: string | number) {
			try {
				self.loading = true;
				const spec = specId || bookingStore.specialization?.id || doctorsStore.activeDoctor?.specializations[0].id;
        const response: ClinicsApiResponse = yield axiosRequest({
          path: '/api/v2/booking/branch',
          params: { spec }
        });

        if (response?.results) {
          const clinics = response.results.map((clinic: Clinic) => ({
            id: clinic.id,
            name: clinic.name,
            info: [clinic.address, clinic.schedule],
          }));

          const clinicsMap: Record<number, Clinic> = {};
          response.results.forEach((clinic: Clinic) => {
            clinicsMap[clinic.id] = clinic;
          });
          self.clinicsMap.replace(clinicsMap);
          self.clinics.replace(clinics as any);
          self.loading = false;
        }
			} catch (error) {
				console.error('Error fetching clinics:', error);
				self.error = error as any;
				self.loading = false;
			}
		}),
		setFindedClinics: (newClinics: ClinicState[]) => {
			self.clinics = newClinics as any;
		},
	}));

export const clinicsStore = ClinicsStore.create({
	clinics: [],
	clinicsMap: {},
	error: null,
	loading: false,
});

//Если нужно дебажить
onSnapshot(clinicsStore, snapshot => {
  if (import.meta.env.VITE_SHOW_SNAPSHOT !== 'false') {
    console.log('Клиники:', snapshot);
  }
});

// onAction(documentsStore, action => {
// 	console.log("Экшен", action);
// })
